import React from "react";


const StudioPastore = () => {
  return (
    <>
     <div>
        <h1>Studio Pastore</h1>
        <img src="https://res.cloudinary.com/dwc20azoo/image/upload/v1749198446/Logo_studio_pastore_trasparente_lgwsje.png" alt="Studio Pastore" />
     </div>
    </>
  );
};

export default StudioPastore;